export default function filterOutElementAtIndex<T>(array: T[], index: number): T[] {
  return array.filter((_, i) => i !== index);
}
